/*
 * Lemonade Training Oy, copy rights, all right reserved.
 * F032 step 7: how a program is described to people, in plain words.
 */
import type { ProgrammingProductData } from "../hooks/useProgrammeLanes";

type ProgramLike = Pick<ProgrammingProductData, "programmingType" | "pricing"> & {
  weeks?: number | null;
};

/** "Daily calendar", "Week-by-week plan · 8 weeks", "Set of workouts". */
export const programTypeLabel = (prog: ProgramLike): string | null => {
  switch (prog.programmingType?.type) {
    case "reoccurring":
      return "Daily calendar";
    case "timeline":
      return typeof prog.weeks === "number" && prog.weeks > 0
        ? `Week-by-week plan · ${prog.weeks} ${prog.weeks === 1 ? "week" : "weeks"}`
        : "Week-by-week plan";
    case "fix":
      return "Set of workouts";
    default:
      return null;
  }
};

const euros = (amount: number) =>
  `€${Number.isInteger(amount) ? amount : amount.toFixed(2).replace(/\.00$/, "")}`;

/** "Free", "€29 / month", "€19 once"; null for a price we can't describe. Euros platform-wide today. */
export const programPriceLabel = (prog: ProgramLike): string | null => {
  const pricing = prog.pricing;
  if (!pricing || pricing.type === "free") return "Free";
  // A malformed stored amount must not take the whole list down.
  if (typeof pricing.amount !== "number" || !Number.isFinite(pricing.amount)) return null;
  if (pricing.type === "subscription") return `${euros(pricing.amount)} / month`;
  if (pricing.type === "one time") return `${euros(pricing.amount)} once`;
  return null;
};

export const membersLabel = (count: number): string =>
  `${count} ${count === 1 ? "member" : "members"}`;
